export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9887.6d0590b7.jpg";